import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.testimonials-component').forEach(section => {
        const sliderContainer = section.querySelector('.tc-mainwrap.swiper');
        if (!sliderContainer) { return; }

        const swiper = new Swiper(sliderContainer, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            autoHeight:true,

            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },

            speed: 900,

            // autoplay: {
            //     delay: 4000,
            //     disableOnInteraction: false,
            // },

            navigation: {
                prevEl: section.querySelector('.arrow-prev'),
                nextEl: section.querySelector('.arrow-next'),
            },
        });
    });
});
